"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/AccountPage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');



var _org = require('shared/selectors/org');
var _features = require('shared/selectors/org/features');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _useAccounts = require('web/screens/Settings/hooks/useAccounts');

var _PageLayout = require('web/components/Settings/PageLayout'); var _PageLayout2 = _interopRequireDefault(_PageLayout);
var _Skeleton = require('web/components/Settings/Skeleton'); var _Skeleton2 = _interopRequireDefault(_Skeleton);
var _EmptyState = require('web/components/Settings/EmptyState'); var _EmptyState2 = _interopRequireDefault(_EmptyState);
var _Link = require('web/components/Settings/Link'); var _Link2 = _interopRequireDefault(_Link);
var _Org = require('web/components/Settings/Org');
var _SubscriptionsTab = require('web/screens/Settings/Org/SubscriptionsTab'); var _SubscriptionsTab2 = _interopRequireDefault(_SubscriptionsTab);
var _tabs = require('./tabs');
var _Overview = require('./Overview'); var _Overview2 = _interopRequireDefault(_Overview);
var _AddOrgModal = require('./Overview/AddOrgModal'); var _AddOrgModal2 = _interopRequireDefault(_AddOrgModal);
var _People = require('./People'); var _People2 = _interopRequireDefault(_People);
var _Settings = require('./Settings'); var _Settings2 = _interopRequireDefault(_Settings);
var _AccountAPIKeys = require('./APIKeys/AccountAPIKeys'); var _AccountAPIKeys2 = _interopRequireDefault(_AccountAPIKeys);
var _Reports = require('./Reports'); var _Reports2 = _interopRequireDefault(_Reports);
var _Audit = require('./Audit'); var _Audit2 = _interopRequireDefault(_Audit);
















// Settings → Account, for the Owners and IT of a flagged account.
const AccountPage = ({
  account, routeOrgKey, hasLoadFailed = false, tabName, onAccountChanged, gotoAccountTab, gotoOrgInfo, gotoSettingsRoot,
}) => {
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [isAddingOrg, setIsAddingOrg] = _react.useState.call(void 0, false)
  // A link to one person (F-9), as from an org's Members tab.
  const personKey = new URLSearchParams(_reactrouterdom.useLocation.call(void 0, ).search).get('person') 
  const managed = _useAccounts.isManagedAccount.call(void 0, account) ? account : null
  const orgKey = _nullishCoalesce(_optionalChain([managed, 'optionalAccess', _ => _.DefaultOrgKey]), () => ( null))
  const titleOrgKey = _nullishCoalesce(_nullishCoalesce(orgKey, () => ( routeOrgKey)), () => ( null))
  const title = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([(titleOrgKey && _org.selectOrgByKey.call(void 0, titleOrgKey, state)), 'optionalAccess', _2 => _2.Name]), () => ( 'Account')))
  const hasReports = _hooks.useAppSelector.call(void 0, state => !!orgKey && _features.selectOrgHasReports.call(void 0, state, orgKey))
  const tabs = _react.useMemo.call(void 0, () => managed ? _tabs.getAccountTabs.call(void 0, managed, hasReports) : [], [managed, hasReports])
  // Reports and Audit mount the first time they're opened, not with the page:
  // Reports' counts query every org's texts and each audit page scans up to
  // 10,000 rows. Once open, each stays mounted like the rest.
  const [hasOpenedReports, setHasOpenedReports] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, () => { if (tabName === 'reports') setHasOpenedReports(true) }, [tabName])
  const [hasOpenedAudit, setHasOpenedAudit] = _react.useState.call(void 0, tabName === 'audit')
  if (tabName === 'audit' && !hasOpenedAudit) setHasOpenedAudit(true)

  _react.useLayoutEffect.call(void 0, 
    () => {
      // Anyone who doesn't manage the account has nothing here. A link to a
      // person says so in place instead (F-9).
      if (account !== undefined && !managed && !(personKey && !hasLoadFailed)) {
        if (hasLoadFailed) showWarningBar('Failed to load the account')
        gotoSettingsRoot()
        return
      }
      const [first] = tabs
      if (orgKey && first && !tabs.some(t => t.name === tabName)) gotoAccountTab(orgKey, first.name)
    },
    [account, managed, personKey, hasLoadFailed, orgKey, tabs, tabName, gotoAccountTab, gotoSettingsRoot, showWarningBar],
  )

  const onAddOrg = _react.useCallback.call(void 0, 
    (name) => orgKey ? _AddOrgModal.addAccountOrg.call(void 0, orgKey, name).then(onAccountChanged) : Promise.resolve(),
    [orgKey, onAccountChanged],
  )

  const onSelectTab = _react.useCallback.call(void 0, 
    (t) => { if (orgKey) gotoAccountTab(orgKey, t) },
    [orgKey, gotoAccountTab],
  )

  // Still loading: the page's shape, so nothing jumps when it arrives.
  if (account === undefined) {
    return (
      _react2.default.createElement(_PageLayout2.default, { title: title, bodyClassName: "settings--page--org settings--page--acct" , onBack: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
        , _react2.default.createElement('div', { className: "settings--org--tab-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
          , _react2.default.createElement('div', { className: "settings--org--tab", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, _react2.default.createElement(_Skeleton2.default, { label: "Loading the account"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ))
        )
      )
    )
  }

  if (!managed && personKey) {
    return (
      _react2.default.createElement(_PageLayout2.default, { title: "Account", bodyClassName: "settings--page--org settings--page--acct" , onBack: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement('div', { className: "settings--org--tab-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
          , _react2.default.createElement('div', { className: "settings--org--tab", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
            , _react2.default.createElement(_EmptyState2.default, {
              title: "You don't have permission to view this person or change their settings"           ,
              action: { label: 'Back to Settings', onClick: gotoSettingsRoot }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
, "Only the account's Owners and IT can open the Account page and change account roles. Ask one of them if this person's role needs to change."


            )
          )
        )
      )
    )
  }

  if (!managed || !orgKey || !tabName || !tabs.some(t => t.name === tabName)) return null

  // Every tab mounts when the page opens, so they all load at once and keep
  // what they loaded when the person switches between them (F-4).
  const panel = (name) => {
    switch (name) {
      case 'overview':
        return _react2.default.createElement(_Overview2.default, { account: managed, gotoOrgInfo: gotoOrgInfo, onAccountChanged: onAccountChanged, __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}} )
      case 'people':
        return _react2.default.createElement(_People2.default, { orgKey: orgKey, account: managed, personKey: personKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
      case 'settings':
        return _react2.default.createElement(_Settings2.default, { orgKey: orgKey, onAccountChanged: onAccountChanged, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}} )
      case 'plan':
        // The org Plan tab isn't a scroller itself; here the body doesn't scroll (F-10).
        return (
          _react2.default.createElement('div', { className: "settings--org--tab-wrapper settings--acct--plan" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
            , _react2.default.createElement(_SubscriptionsTab2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
            ,  managed.OrgKeys.length === 1 && (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('p', { className: "settings--acct--footnote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}, "Overview appears when a second organization is added."

                  , ' '
                  , _react2.default.createElement(_Link2.default, { role: "button", onClick: () => setIsAddingOrg(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}, "Add organization" )
                )
                , _react2.default.createElement(_AddOrgModal2.default, { isOpen: isAddingOrg, onClose: () => setIsAddingOrg(false), onProceed: onAddOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}} )
              )
            )
          )
        )
      case 'api-keys':
        return _react2.default.createElement(_AccountAPIKeys2.default, { account: managed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}} )
      case 'reports':
        return hasOpenedReports || tabName === 'reports' ? _react2.default.createElement(_Reports2.default, { orgKey: orgKey, account: managed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}} ) : null
      case 'audit':
        // Each audit page scans up to 10,000 rows, so it loads only once
        // the tab is opened, then stays mounted like the others.
        return hasOpenedAudit ? _react2.default.createElement(_Audit2.default, { orgKey: orgKey, account: managed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}} ) : null
    }
  }

  return (
    _react2.default.createElement(_PageLayout2.default, {
      title: title,
      bodyClassName: "settings--page--org settings--page--acct" ,
      onBack: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}

      , _react2.default.createElement(_Org.TabsHeader, { tabs: tabs, activeTab: tabName, onSelect: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}} )
      ,  tabs.map(t => (
        _react2.default.createElement('div', { key: t.name, role: "tabpanel", 'aria-label': t.label, className: "settings--acct--panel", hidden: t.name !== tabName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
          ,  panel(t.name) 
        )
      ))
    )
  )
}

exports. default = _react.memo.call(void 0, AccountPage)
